













































































import { defineComponent, ref, watch } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import { EnumDocumentType } from '@getaccept/lib-shared/src/enums/DocumentType';
import { useToast } from '@getaccept/lib-shared/src/toast';
import { ModuleName } from '@getaccept/lib-shared/src/entity/app-modules/enums/app-module';
import { Feature, useFeatureStore } from '@getaccept/feature-restriction';
import { storeToRefs } from 'pinia';
import type { CreateDocumentOption } from '../types/create-document-option';
import { DocumentService } from '../../api/documents/services/document.service';
import { useAppMode } from '../../composables/app-mode.composable';
import { useModulesStore } from '../../modules/store/modules.store';

export default defineComponent({
  props: {
    items: { type: Array as PropType<CreateDocumentOption[]>, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const { toast } = useToast();
    const { isSales: isSalesAppMode, isBusiness: isBusinessAppMode } = useAppMode();
    const { features } = storeToRefs(useFeatureStore());
    const { isDealRoomModuleActive } = storeToRefs(useModulesStore());

    const loading = ref(false);
    const loaded = ref(false);

    const createDocument = async (type: EnumDocumentType) => {
      loading.value = true;
      loaded.value = false;
      try {
        const documentId = await DocumentService.createDocument(type);
        handleCreated(documentId, type);
      } catch (e) {
        toast.danger('failed-to-create-document');
      } finally {
        loading.value = false;
      }
    };

    const createSignableDocument = () => {
      if (isSalesAppMode.value) {
        createDocument(EnumDocumentType.Sales);
      } else if (isBusinessAppMode.value) {
        createDocument(EnumDocumentType.Hr);
      }
    };

    const handleCreated = (id: string, type: EnumDocumentType) => {
      loaded.value = true;
      emit('created', { id, type });
    };

    watch(loaded, newValue => {
      if (newValue) {
        setTimeout(() => {
          loaded.value = false;
        }, 1500);
      }
    });

    return {
      ParagraphSize,
      EnumDocumentType,
      ModuleName,
      loading,
      loaded,
      createDocument,
      createSignableDocument,
      handleCreated,
      features,
      Feature,
      isDealRoomModuleActive,
    };
  },
});
